function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return _typeof(key) === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
  if (_typeof(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (_typeof(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
import React from 'react';
import { patchZero } from "../../utils";
var CountDown = /*#__PURE__*/function (_React$Component) {
  _inherits(CountDown, _React$Component);
  var _super = _createSuper(CountDown);
  function CountDown(props) {
    var _this;
    _classCallCheck(this, CountDown);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "timer", void 0);
    _defineProperty(_assertThisInitialized(_this), "startCountDown", function () {
      var miniShow = _this.props.miniShow;
      var timerdown = miniShow ? 10 : 1000;
      _this.timer = window.setInterval(function () {
        var count = _this.state.count;
        if (count > 0) {
          var newCount = count - timerdown;
          var countData = _this.getCountDownData(newCount);
          _this.setState(_objectSpread({
            count: newCount
          }, countData));
        } else {
          _this.setState({
            count: 0,
            hour: 0,
            minutes: 0,
            seconds: 0,
            hh: 0,
            mm: 0,
            ss: 0,
            mini: 0
          });
          _this.props.onOver && _this.props.onOver();
          window.clearInterval(_this.timer);
        }
      }, timerdown);
    });
    _this.state = {
      count: 0,
      hour: 0,
      minutes: 0,
      seconds: 0,
      hh: 0,
      mm: 0,
      ss: 0,
      mini: 0
    };
    return _this;
  }
  _createClass(CountDown, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      var _this2 = this;
      var count = this.props.count; // Math.floor(this.props.count / 1000);
      this.setState(_objectSpread({
        count: count
      }, this.getCountDownData(count)), function () {
        _this2.startCountDown();
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.clearInterval(this.timer);
    }
    /**
     *
     * @param count 毫秒
     */
  }, {
    key: "getCountDownData",
    value: function getCountDownData(count) {
      var mini = Math.round(count % 1000 / 10);
      var seconds = Math.floor(count / 1000);
      var ss = seconds % 60;
      var mm = Math.floor(seconds / 60) % 60;
      var hh = Math.floor(seconds / 60 / 60) % 60;
      return {
        hh: hh,
        mm: mm,
        ss: ss,
        mini: mini
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
        hh = _this$state.hh,
        mm = _this$state.mm,
        ss = _this$state.ss,
        mini = _this$state.mini;
      var _this$props = this.props,
        spaceHide = _this$props.spaceHide,
        hourShow = _this$props.hourShow,
        miniShow = _this$props.miniShow;
      return /*#__PURE__*/React.createElement(React.Fragment, null, !(!hourShow && !hh) && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
        className: "cd-num"
      }, patchZero(hh)), !spaceHide && /*#__PURE__*/React.createElement("span", {
        className: "cd-spc"
      }, ":")), /*#__PURE__*/React.createElement("span", {
        className: "cd-num"
      }, patchZero(mm)), !spaceHide && /*#__PURE__*/React.createElement("span", {
        className: "cd-spc"
      }, ":"), /*#__PURE__*/React.createElement("span", {
        className: "cd-num"
      }, patchZero(ss)), !!miniShow && /*#__PURE__*/React.createElement(React.Fragment, null, !spaceHide && /*#__PURE__*/React.createElement("span", {
        className: "cd-spc"
      }, ":"), /*#__PURE__*/React.createElement("span", {
        className: "cd-num"
      }, patchZero(mini))));
    }
  }]);
  return CountDown;
}(React.Component);
_defineProperty(CountDown, "defaultProps", {
  count: 0,
  spaceHide: false,
  hourShow: false,
  miniShow: false,
  onOver: function onOver() {}
});
export default CountDown;